if (!customElements.get('scroll-rail')) {
  customElements.define(
    'scroll-rail',
    class ScrollRail extends HTMLElement {
      connectedCallback() {
        this.isDown = false;
        this.moved = false;
        this.startX = 0;
        this.startScroll = 0;

        // Progress indicator under the rail.
        this.thumb = this.closest('.product-rail')?.querySelector('.product-rail__hint-thumb');
        if (this.thumb) {
          this.ticking = false;
          this.addEventListener('scroll', () => {
            if (this.ticking) return;
            this.ticking = true;
            requestAnimationFrame(() => {
              this.updateProgress();
              this.ticking = false;
            });
          });
          window.addEventListener('resize', () => this.updateProgress());
          this.updateProgress();
        }

        this.addEventListener('pointerdown', this.onDown.bind(this));
        this.onMoveBound = this.onMove.bind(this);
        this.onUpBound = this.onUp.bind(this);
        window.addEventListener('pointermove', this.onMoveBound);
        window.addEventListener('pointerup', this.onUpBound);
        window.addEventListener('pointercancel', this.onUpBound);

        // Never start a native image/link drag inside the rail.
        this.addEventListener('dragstart', (e) => e.preventDefault());

        // Swallow the click that follows a drag so cards don't navigate.
        this.addEventListener(
          'click',
          (e) => {
            if (this.moved) {
              e.preventDefault();
              e.stopPropagation();
              this.moved = false;
            }
          },
          true
        );
      }

      disconnectedCallback() {
        window.removeEventListener('pointermove', this.onMoveBound);
        window.removeEventListener('pointerup', this.onUpBound);
        window.removeEventListener('pointercancel', this.onUpBound);
      }

      onDown(e) {
        // Touch and pen scroll natively; only the mouse needs drag support.
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        this.isDown = true;
        this.moved = false;
        this.startX = e.clientX;
        this.startScroll = this.scrollLeft;
        this.classList.add('is-dragging');
      }

      onMove(e) {
        if (!this.isDown) return;
        const dx = e.clientX - this.startX;
        if (Math.abs(dx) > 5) this.moved = true;
        this.scrollLeft = this.startScroll - dx;
      }

      onUp() {
        if (!this.isDown) return;
        this.isDown = false;
        this.classList.remove('is-dragging');
      }

      updateProgress() {
        if (!this.thumb) return;
        const maxScroll = this.scrollWidth - this.clientWidth;
        const progress = maxScroll > 0 ? Math.min(Math.max(this.scrollLeft / maxScroll, 0), 1) : 0;
        this.thumb.style.setProperty('--rail-progress', progress);
      }
    }
  );
}
